import Icon from "@material-ui/icons/School";
//import Edit from "./CertificationEdit";
import Show from "./ExamlogShow.js";
import Create from "./ExamlogCreate";
import List from "./ExamlogList";

export default {
 // edit: Edit,
create: Create,
  icon: Icon,
  list: List,
  show: Show,
};
